export enum savedConditionsDeleteTypes {
  FETCH_SAVED_CONDITIONS_DELETE_REQUEST = "FETCH_SAVED_CONDITIONS_DELETE_REQUEST",
  FETCH_SAVED_CONDITIONS_DELETE_SUCCESS = "FETCH_SAVED_CONDITIONS_DELETE_SUCCESS",
  FETCH_SAVED_CONDITIONS_DELETE_FAILURE = "FETCH_SAVED_CONDITIONS_DELETE_FAILURE",
}